import { IApplicationState } from './types';

export const initialState: IApplicationState = {
    ftuShownUserIds: [],
    ftuShownUserPolicyIds: [],
    cookiesEnabled: null
};
